import "./Chat.css";
import { useEffect, useState } from "react";
import Member from "./Member";

function Chat(props)
{
    const senderColors = ["crimson", "darkorange", "deepskyblue", "indigo", "seagreen", ];

    const [groupName, setGroupName] = useState("");
    const [groupDescription, setGroupDescription] = useState("");
    const [groupImage, setGroupImage] = useState("https://acepicklapi.raganindustries.com/files/1.png");
    const [groupMembers, setGroupMembers] = useState([]);
    const [userIDs, setUserIDs] = useState([]);

    const [incomingMessage, setIncomingMessage] = useState("");

    const [webSocket, setWekSocket] = useState();

    useEffect(() => {
        let url = "https://acepicklapi.raganindustries.com/api_get_group.php";
        let headers = {
            "Accept" : "application/json",
            "Content-type" : "application/json",
            "Authorization" : `Bearer ${ window.sessionStorage.getItem("user_accesstoken") }`
        };
        let values = {
            group_id : props["group_id"]
        };
        fetch(url, {
            method : 'POST',
            headers : headers,
            body : JSON.stringify(values)
        }).then((response) => response.json()).then((data) => {
            console.log(data);
            setGroupName(data.group_name);
            setGroupDescription(data.group_description);
            setGroupMembers(data.group_users.map(createMemberElement));
            setUserIDs(data.group_users.map(createMemberID));
            // setGroupImage("https://acepicklapi.raganindustries.com" + data.group_image);
        });
    }, []);

    useEffect(() => {
        const conn = new WebSocket("ws://103.91.186.215:8080?user_id=" + String(window.sessionStorage.getItem("user_id")));

        conn.onopen = () => {
            console.log("Connection Established!!!");
        }

        conn.onmessage = (e) => {
            handleReceivedChat(JSON.parse(e.data));
        }

        conn.onclose = () => {
            console.log("Connection Terminated!!!");
        }

        setWekSocket(conn);
    }, []);

    function createMemberElement(member)
    {
        return <div>
                    <Member name = { member.user_name } email = { member.user_email } image = "https://acepicklapi.raganindustries.com/files/0.png" />
               </div>
    }

    function createMemberID(member)
    {
        return member.user_id;
    }

    function handleMessageChange(e)
    {
        setIncomingMessage(e.target.value);
    }

    function sendMessage(e)
    {
        if(e.keyCode == 13)
        {
            let message = {
                from : window.sessionStorage.getItem("user_name"),
                to : userIDs,
                message : incomingMessage
            }
            console.log(message);
            webSocket.send(JSON.stringify(message));
            setIncomingMessage("");
        }
    }

    function handleReceivedChat(chat_info)
    {
        const messageArea = document.getElementsByClassName("message_area")[0];

        const element = document.createElement("div");
        const sender = document.createElement("h1");
        const message = document.createElement("p");
        const spacer = document.createElement("br");
        const timestamp = document.createElement("div");
        const currenttime = document.createElement("p");
        const date = new Date();
        sender.innerText = "~" + chat_info.from;
        message.innerText = chat_info.message;
        element.setAttribute("class", "message_element");
        timestamp.setAttribute("class", "timestamp");
        currenttime.innerText = String(date.getFullYear()) + "-" + String(date.getUTCMonth() + 1) + "-" + String(date.getUTCDate()) + "  " + String(date.getHours()) + ":" + String(date.getMinutes()) + ":" + String(date.getSeconds());
        timestamp.appendChild(currenttime);
        if(chat_info.from == "Me")
        {
            element.style.backgroundColor = "rgba(0, 225, 0, 1)";
            element.style.position = "relative";
            element.style.marginLeft = "10px";
        }
        else
        {
            let randomColor = Math.floor(Math.random() * 5);
            element.style.backgroundColor = "white";
            element.style.position = "relative";
            element.style.left = "100%";
            element.style.transform = "translate(-100%, -0%)";
            element.style.marginLeft = "-10px";
            sender.style.color = senderColors[randomColor];
        }
        element.appendChild(sender);
        element.appendChild(message);
        element.appendChild(timestamp);
        messageArea.appendChild(element);
        messageArea.append(spacer);
        const lastMessage = messageArea.lastElementChild;
        lastMessage.scrollIntoView({ behavior : 'smooth', block : 'end' });
    }

    return(
        <div className = "chat_content">
            <div className = "chat_area">
                <div className = "group_header">
                    &emsp;
                    <h1 className = "close">&#10006;</h1>
                    <div className = "spacer" style = {{ width : '6%' }}></div>
                    <img src = { groupImage } alt = "err" />
                    <div className = "spacer" style = {{ width : '2%' }}></div>
                    <div className = "header_content">
                        <h1 className = "group_name">{ groupName }</h1>
                        <h1 className = "group_description">{ groupDescription }</h1>
                    </div>
                    <img src = "Drop_Icon.png" className = "drop_icon" />
                </div>
                <div className = "message_area">
                    <br/>
                </div>
                <input type = "text" className = "incoming_message" value = { incomingMessage } placeholder = "Enter message" onChange = { handleMessageChange } onKeyDownCapture = { sendMessage } />
            </div>
            <div className = "group_details">
                <br/>
                <img src = { groupImage } alt = "err" />
                <h1>{ groupName }</h1>
                <h2>{ groupDescription }</h2>
                <div className = "group_members">
                    { groupMembers }
                </div>
            </div>
        </div>
    );
}

export default Chat;